import MappingCameraComuni from '@/data/mapping-camera-comuni7917-solo-ABRUZZO.json';

export const convertIdProvince = (cod_reg?: string, cod_prov?: string) => {
  if (cod_reg?.charAt(0) === '0') {
    cod_reg = cod_reg.substring(1);
  }
  if (cod_prov?.charAt(0) === '0') {
    cod_prov = cod_prov.substring(1);
  }
  const province = MappingCameraComuni.find(
    e => e.cod_regione === cod_reg && e.cod_provincia === cod_prov
  );

  if (province) {
    return province.ISTAT_PROV;
  } else {
    console.log(
      'convertIdProvince ISTAT_PROV not found for',
      cod_reg,
      cod_prov
    );
  }
  return cod_prov || '';
};

export const convertIdComune = (
  cod_reg?: string,
  cod_prov?: string,
  cod_com?: string
) => {
  if (cod_reg?.charAt(0) === '0') {
    cod_reg = cod_reg.substring(1);
  }
  if (cod_prov?.charAt(0) === '0') {
    cod_prov = cod_prov.substring(1);
  }
  if (cod_com?.charAt(0) === '0') {
    cod_com = cod_com.substring(1);
  }
  const comune = MappingCameraComuni.find(
    e =>
      e.cod_regione === cod_reg &&
      e.cod_provincia === cod_prov &&
      e.cod_comune === cod_com
  );

  if (comune) {
    return comune.PRO_COM;
  } else {
    console.log(
      'convertIdComune PRO_COM not found for',
      cod_reg,
      cod_prov,
      cod_com
    );
  }
  return cod_com || '';
};
